/* eslint no-useless-escape: 0 */

const regexes = {
  bankAccount: {
    BANK_CODE: /^(?:^0*)[1-9][0-9]{0,2}$/,
    BANK_ISPB: /^[0-9]{8}$/,
    AGENCY_ONE: /^[0^]*[1]{1}$/,
    ACCEPT_AGENCY_WITH_ONLY_ZEROS: /^(?:^0*)[0-9]{0,10}$/,
    DIGIT: /^[xX0-9]{0,1}$/,
    NUMERIC_DIGIT: /^[0-9]{0,1}$/,
    AGENCY: /^(?:^0*)[1-9][0-9]{0,9}$/,
    ACCOUNT: /^(?:^0*)[1-9][0-9]{0,19}$/
  },
  FIRST_NAME: /(.*\S){3}/,
  FULL_NAME: /^\S*\s+(\S+){1}.+/,
  EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  DATE: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
  ONLY_NUMBERS_BUT_ALL_ZEROS: /^(?!0+$)\d+$/,
  CPF_CNPJ: /^(([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2}))$/,
  CPF: /^[0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2}$/,
  CPF_OBFUSCATED: /^\*{3}\.[0-9]{3}\.[0-9]{3}\-\*{2}$/,
  CNPJ: /^[0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2}$/,
  POSTAL_CODE: /^[0-9]{2}\.?[0-9]{3}\-?[0-9]{3}$/,
  STATE_CODE: /^[A-Za-z]{2}$/,
  PHONE: /^(\+[1-9][0-9])?\d{1,14}$/,
  MOBILE_PHONE: /^((?:\+?55)?)([1-9][0-9])(9[0-9]{8})$/,
  MOBILE_PHONE_WITHOUT_COUNTRY: /^[1-9][0-9]9[0-9]{8}$/,
  MOBILE_PHONE_WITH_BRAZIL_COUNTRY_CODE: /^(\+55)([1-9][0-9])(9[0-9]{8})$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#$^+=!?*(){}\[\]<>@%&\-_\.,;:\\\/|]).{8,}$/,
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  PIX_EVP: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  PIX_E2E_ID: /^[a-zA-Z0-9]{32}$/,
  PIX_QRCODE_TXID: /^[a-zA-Z0-9]{1,35}$/,
  PIX_STATIC_QRCODE_TXID: /^[a-zA-Z0-9]{1,25}$/,
  PIX_DYNAMIC_QRCODE_TXID: /^[a-zA-Z0-9]{26,35}$/
};

module.exports = regexes;
